import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Server_URL } from 'src/environments/environment';
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root'
})
export class PartnerRequestService {
  public Data = new BehaviorSubject(null)

  constructor(private _HttpClient:HttpClient) { }
  GetPartnerRequestsPaged(pager:any):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/PartnerRequest/GetPaged`,pager);
  }
}
